<div id="myStore" class="modal in show" aria-hidden="false" *ngIf="deleteModal&&deleteModal.toggle">
    <div class="modal-backdrop  in"></div>
    <!-- modal-sm minwidth-450 dialog-box-minwidth-300 -->
    <div class="suggestion modal-dialog ">
        <div class="modal-content">
            <div class="modal-body">
                <!-- <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button> -->
                <div class="productmodal-body row">
                    <div class="col-xs-12 text-center">
                        <div class="row">
                            <div class="form-group">
                                <div class="col-lg-12">
                                    <b>{{deleteModal.message}}</b>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="deleteModal.viewActionButtons" class="row continue-block" style="margin-top:10px;">
                            <div class="form-group pull-right">
                                <div class="col-lg-12  text-center ">
                                    <button type="button" class="btn blue-button" tabindex="0" (keyup.enter)="yesClick()" (click)="yesClick()">
                                         Yes
                                    </button>
                                    <button type="button" class="btn grey-button" tabindex="0" (keyup.enter)="noClick()" (click)="noClick()">
                                         No
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="!deleteModal.viewActionButtons" class="row continue-block" style="margin-top:10px;">
                            <div class="form-group">
                                <!--<label class="col-lg-5 control-label hidden-xs">&nbsp;</label>-->
                                <div class="col-lg-12">
                                    <button class="btn grey-button pull-right" autofocus tabindex="0" type="button" (keyup.enter)="okClick()" (click)="okClick()">Close</button>                                       
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/delete.component.html